import { render, staticRenderFns } from "./SchoolGradeCheckboxSelect.vue?vue&type=template&id=02fb07f0"
import script from "./SchoolGradeCheckboxSelect.vue?vue&type=script&lang=js"
export * from "./SchoolGradeCheckboxSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports